import React from 'react';
import GasServiceComp from "../components/GasServicesPage/GasServiceComp";

const GasService = () => {
    return (
        <GasServiceComp/>
    );
};

export default GasService;